import React, { useEffect, useState } from "react";
import DoctorEditForm from "common/pages/Doctor/EditForm";
import { useNavigate, useParams } from "react-router-dom";
import { infoService } from "common/services/info";
import { staffClient } from "common/apis/staff";
import { FileService } from "common/services/file";
import { toast } from "react-toastify";

const DoctorEditorPage = () => {
    const { doctorId } = useParams();
    const [doctorInfo, setDoctorInfo] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchDoctorInfo();
    }, [])

    const fetchDoctorInfo = async () => {
        try {
            // const ret = await axios.get(`https://rest.miview.shop/doctor/${doctorId}`);
            const ret = await staffClient.get(`/doctor/${doctorId}`);
            console.log("[DoctorEditPage] fetchDoctorInfo ret", ret);
            const doctorData = ret.data;
            setDoctorInfo(doctorData);
        } catch (e) {
            console.log("[DoctorEditPage] fetchDoctorInfo error", e);
        }
    }

    const handleSave = async (formData) => {
        try {
            const uploadedProfileImage = await FileService.tryUploadFile(formData.profileImage);
            const body = {
                ...formData,
                profileImage: uploadedProfileImage
            }
            const ret = await staffClient.patch(`/doctor/${doctorId}`, body);
            console.log("[DoctorEditPage] onSave ret", ret);
            toast.success("의사 정보가 수정되었습니다.");
            navigate("/main/doctor");
        } catch (e) {
            console.log("[DoctorEditPage] onSave error", e);
            toast.error("의사 정보 수정 중 오류가 발생했습니다.");
        }
    }

    return (
        <DoctorEditForm
            doctorInfo={doctorInfo}
            onSave={handleSave}
        />
    )
}

export default DoctorEditorPage;